import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpClientModule } from '@angular/common/http';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { LmComponentsModule } from 'lm-components';

import { HeaderComponent } from './root/header/header.component';
import { FooterComponent } from './root/footer/footer.component';
import { HomeComponent } from './root/home/home.component';
import { SiteRedirectComponent } from './root/callbacks/site-redirect/site-redirect.component';
import { LogoutComponent } from './root/logout/logout.component';
import { AdalUserHeaderComponent } from './root/header/adal-user-header/adal-user-header.component';
import { OidcUserHeaderComponent } from './root/header/oidc-user-header/oidc-user-header.component';
import { HttpInterceptorProviders } from './root/http-interceptors';
import { DynamicHostDirective } from './root/directives/dynamic-host.directive';
import { BrokerResolver } from './root/resolvers/broker-resolver';
import { QuoteResolver } from './root/resolvers/quote-resolver';
import { MessageModalComponent } from '../shared/message-modal/message-modal.component';
import { CustomerResolver } from './root/resolvers/customers-resolver';
import { AuthCustomerSelectComponent } from './auth-customer-select/auth-customer-select.component';
import { MsalRedirectComponent } from '@azure/msal-angular';
import { CoreModule } from './core/core.module';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    HomeComponent,
    SiteRedirectComponent,
    LogoutComponent,
    AdalUserHeaderComponent,
    OidcUserHeaderComponent,
    DynamicHostDirective,
    MessageModalComponent,
    AuthCustomerSelectComponent
  ],
  imports: [
    CoreModule,
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    NgbModule,
    LmComponentsModule
  ],
  providers: [
    HttpInterceptorProviders,
    BrokerResolver,
    QuoteResolver,
    CustomerResolver
  ],
  bootstrap: [
    AppComponent,
    MsalRedirectComponent
  ]
})
export class AppModule { }
